import { BookingInitialState } from "stores/booking/types";

// Define an interface for a BookingStore object
interface BookingStore {
  isTravelProtected: boolean;
  totalAmt: number | null;
  discount: number | null;
  achProcessingSavings?: number | null;
}

// Calculate the amount to be paid
export function calculateAmount(bookingStore: Partial<BookingStore>, travelProtectionCost: number, pdpFees: number, rate: number): number {
  const discount = bookingStore?.discount || 0; // Get the discount amount from the booking store object
  const total = bookingStore.totalAmt || 0;
  const travelProtection = bookingStore.isTravelProtected ? travelProtectionCost : 0;
  const achProcessingSavings = bookingStore?.achProcessingSavings || 0;
  const amount = total + pdpFees + travelProtection - discount - achProcessingSavings;
  return amount <= 0 ? 0 : amount * rate; // Return the amount adjusted by the rate
}

// Function to calculate half of the total payment
export function calculateOfFirstPayment(rate: number, bookingStore: BookingInitialState, hostFees: number, totalTax: number, serviceFee: number, travelProtectionCost: number, firstPaymentPercentage: number): number {
  const isTravelProtected = bookingStore.isTravelProtected || false;
  const isCancelBookingTravelProtected = bookingStore.isCancelBookingTravelProtected || false;
  const getOriginalServiceFee = bookingStore?.prequote?.originalServiceFee || 0;

  // Calculate the travel protection cost
  const insurance = isTravelProtected && !isCancelBookingTravelProtected ? travelProtectionCost : isCancelBookingTravelProtected ? travelProtectionCost : 0;
  const discount = bookingStore.discount || 0;
  // Calculate the original rent with the given rate
  const originalRent = bookingStore.prequote?.originalRent || 0;

  // Calculate the percentage of the original service fee
  const percentage = getOriginalServiceFee === 0 ? firstPaymentPercentage : 50;
  const achProcessingSavings = bookingStore?.achProcessingSavings || 0;
  // Calculate half of the total amount with taxes,fees and discount
  const countHalfTotalWithTaxesAndDiscount = (originalRent + hostFees + totalTax - discount - achProcessingSavings) * percentage / 100;
  // Calculate the full total with service fee and travel protection cost
  const countFullTotalWithFeesAndInsurance = serviceFee + insurance;
  // the final amount adjusted by the rate
  return (countHalfTotalWithTaxesAndDiscount + countFullTotalWithFeesAndInsurance) * rate;
}